import { Paper } from '@mui/material';
import React from 'react';
import { Page } from '../../components/Page/Page.tsx';

export const Terms = () => {
	const termsPdfUrl = '/Regulamin%20Licytapki.pdf';

	return (
		<Page title="Regulamin" theme="light">
			<Paper className="lessons__paper paper">
				<div className="singleLesson__wrapper">
					<p>
						<a href={termsPdfUrl} target="_blank" rel="noopener noreferrer">
							Aktualny Regulamin Licytapki
						</a>
					</p>
				</div>
			</Paper>
		</Page>
	);
};
